import { render, staticRenderFns } from "./average.vue?vue&type=template&id=1a13a854&scoped=true"
import script from "./average.vue?vue&type=script&lang=js"
export * from "./average.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a13a854",
  null
  
)

export default component.exports